

class OurProductsSpectaculars{
    constructor(){
        this.main = document.getElementById('our_products_spectaculars');

        //this._holderItems = this.main.querySelector('.holder_items');
        
        this._items = [];

        Array.from(this.main.querySelectorAll('.billboards-spectacular__item')).forEach((element)=>{
            this._items.push({
                element: element,
                scale: 1
            })
        })

        window.addEventListener('scroll', this._onScroll.bind(this));
        this._onScroll();
    }

    _onScroll(e = null){
        let itemHeight = this._items[this._items.length-1].element.querySelector('.billboards-spectacular__item-thumb').offsetHeight;
        
        let itemModified = false;
        
        for(let i=this._items.length - 2; i >= 0; i--){
            let text = this._items[i].element.querySelector('.billboards-spectacular__item-text');
            let thumb = this._items[i].element.querySelector('.billboards-spectacular__item-thumb');
            
            if(!itemModified){
                let distance = this._items[i+1].element.offsetTop - this._items[i].element.offsetTop - 10;     
                if(distance < itemHeight){
                    itemModified = true;
                    this._items[i].scale = 0.95 + 0.05*(distance/itemHeight)
                    thumb.style.transform = `scale(${this._items[i].scale})`;
                    
                    if(distance/itemHeight < 0.5){
                        text.style.opacity = 0;
                    }else{
                        text.style.opacity = distance/itemHeight*1;
                    }
                    
                    let nextTextElement = this._items[i+1].element.querySelector('.billboards-spectacular__item-text');    
                    nextTextElement.style.transform = `translateY(${400*(distance/itemHeight)}px)`;
                    nextTextElement.style.opacity = 1 - (distance/itemHeight);

                }else{
                    text.style.opacity = 1;

                    if(i == 0){
                        text.style.transform = 'translateY(0px)';
                    }
                }
            
            }else{
                text.style.opacity = 0;
                this._items[i].scale = this._items[i+1].scale*0.95; 
                thumb.style.transform = `scale(${this._items[i].scale})`;
            }
        }
        
    }
}

export default OurProductsSpectaculars;